import { can, menuPermission } from './permissions'

export const platformNames = {
  network: '智慧城市网络化管理平台',
  policy: '公共政策智能分析决策平台'
}

const networkManager = [
  { key: 'city-home', to: '/cases', label: '实训案例库', icon: 'city' },
  { key: 'city-custom', to: '/network/modules', label: '实训任务管理', icon: 'puzzle' },
  { key: 'city-maps', to: '/map-templates', label: '网格基础资源管理', icon: 'map' },
  { key: 'city-score', to: { path: '/reports', query: { scope: 'practice' } }, label: '实训报告与成绩', icon: 'report' }
]
const networkStudent = [
  { key: 'student-city-home', to: '/cases', label: '实训案例库', icon: 'city' },
  { key: 'student-city-run', to: { path: '/assignments', query: { module: 'network' } }, label: '我的网格实训', icon: 'compass' }
]
const policyManager = [
  { key: 'policy-library', to: { path: '/cases', query: { module: 'policy' } }, label: '案例库', icon: 'city' },
  { key: 'policy-custom', to: { path: '/cases', query: { module: 'policy', view: 'custom' } }, label: '任务案例库管理', icon: 'puzzle' },
  { key: 'policy-score', to: { path: '/reports', query: { scope: 'policy' } }, label: '报告与成绩统计', icon: 'report' }
]
const policyStudent = [
  { key: 'policy-library', to: { path: '/cases', query: { module: 'policy' } }, label: '案例库', icon: 'city' },
  { key: 'student-policy-home', to: { path: '/assignments', query: { module: 'policy' } }, label: '我的政策实训', icon: 'chart' },
  { key: 'student-policy-analysis', to: { path: '/assignments', query: { module: 'policy', view: 'analysis' } }, label: '政策分析', icon: 'trend' }
]

export function platformMenus (user, platform) {
  const student = user && user.role === 'STUDENT'
  const items = platform === 'network' ? (student ? networkStudent : networkManager) : (student ? policyStudent : policyManager)
  return items.filter(item => can(user, menuPermission(item.key)) &&
    (item.key !== 'student-policy-home' || can(user, 'CASE_VIEW')) &&
    (item.key !== 'student-policy-analysis' || can(user, 'REPORT_VIEW')))
}

export function platformEntry (user, platform) {
  const items = platformMenus(user, platform)
  return items.length ? items[0].to : null
}

export function publicMenuGroups (user) {
  if (!user) return []
  const student = user.role === 'STUDENT'
  const groups = []
  if (!student) {
    groups.push({ key: 'management', label: '管理中心', icon: 'users', items: [
      { key: 'admin-users', to: '/users', label: '用户管理' },
      { key: 'admin-classes', to: '/classes', label: '班级管理' },
      { key: 'admin-role-permissions', to: '/role-permissions', label: '角色与权限管理' }
    ] })
    groups.push({ key: 'operations', label: '系统运维', icon: 'lock', items: [
      { key: 'system-logs', to: '/logs', label: '操作日志审计' },
      { key: 'system-backups', to: '/backups', label: '数据备份与设置' }
    ] })
  }
  groups.push({ key: 'personal', label: '个人中心', icon: 'bell', items: student ? [
    { key: 'personal-profile', to: '/profile', label: '账号基本信息' },
    { key: 'student-reports', to: '/reports', label: '实验报告' },
    { key: 'student-notifications', to: { path: '/notifications', query: { module: 'system' } }, label: '公共通知' },
    { key: 'student-role-guide', to: '/role-guide', label: '人物角色' }
  ] : [
    { key: 'personal-profile', to: '/profile', label: '账号基本信息' },
    { key: 'personal-notifications', to: { path: '/notifications', query: { module: 'system' } }, label: '公共通知' }
  ] })
  return groups.map(group => ({ ...group, items: group.items.filter(item => item.key === 'personal-profile' || can(user, menuPermission(item.key))) })).filter(group => group.items.length)
}

// Derive context from the route so bookmarks, notifications and existing links keep working.
export function routePlatform (route, user) {
  const name = route.name
  const query = route.query || {}
  if (name === 'cases') return query.module === 'policy' ? 'policy' : 'network'
  if (name === 'case-workbench') return ['network', 'policy'].includes(query.module) ? query.module : null
  if (['map-templates', 'map-template-detail', 'network-modules', 'network-module-edit', 'network-module-create', 'network-module-ai', 'personnel', 'role-standards', 'network-run'].includes(name)) return 'network'
  if (name === 'policy-run') return 'policy'
  if (name === 'notifications') return ['network', 'policy'].includes(query.module) ? query.module : null
  if (name === 'assignments') return query.module === 'policy' || query.view === 'analysis' ? 'policy' : 'network'
  if (name === 'experiments') return query.scope === 'management' ? null : query.scope === 'legacy' ? 'network' : 'policy'
  if (name === 'reports' && user && user.role !== 'STUDENT') return query.scope === 'practice' ? 'network' : query.scope === 'policy' ? 'policy' : null
  if (name === 'role-guide' && user && user.role !== 'STUDENT') return 'policy'
  return null
}

export function activePlatformMenu (route, user) {
  const name = route.name
  const query = route.query || {}
  const student = user && user.role === 'STUDENT'
  if (name === 'cases') return query.module === 'policy' ? (!query.view ? 'policy-library' : student ? 'student-policy-home' : 'policy-custom') : student ? 'student-city-home' : 'city-home'
  if (name === 'case-workbench') return query.module === 'policy' ? 'policy-custom' : 'city-custom'
  if (['network-modules', 'network-module-edit', 'network-module-create', 'network-module-ai'].includes(name)) return 'city-custom'
  if (['map-templates', 'map-template-detail', 'personnel', 'role-standards'].includes(name)) return 'city-maps'
  if (name === 'network-run') return student ? (query.practice === '1' ? 'student-city-home' : 'student-city-run') : 'city-home'
  if (name === 'policy-run') return query.practice === '1' ? 'policy-library' : student ? 'student-policy-home' : 'policy-custom'
  if (name === 'assignments') return query.module === 'policy' || query.view === 'analysis' ? (query.view === 'analysis' ? 'student-policy-analysis' : 'student-policy-home') : 'student-city-run'
  if (name === 'reports' && !student) return query.scope === 'practice' ? 'city-score' : query.scope === 'policy' ? 'policy-score' : null
  return null
}
